import { Injectable, Provider } from '@angular/core';
import {
  MAT_PAGINATOR_DEFAULT_OPTIONS,
  MatPaginatorDefaultOptions,
  MatPaginatorIntl,
} from '@angular/material/paginator';
import { Subject } from 'rxjs';

/**
 * For internationalization, the `$localize` function from
 * the `@angular/localize` package can be used.
 */
@Injectable()
export class PageLabelMatPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  firstPageLabel = 'First page';

  itemsPerPageLabel = 'Items per page:';

  lastPageLabel = 'Last page';

  nextPageLabel = 'Next page';

  previousPageLabel = 'Previous page';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) return 'Page 1 of 1';

    const amountPages = Math.ceil(length / pageSize);
    return `Page ${page + 1} of ${amountPages}`;
  }
}

const DEFAULT_PAGINATOR_OPTIONS: MatPaginatorDefaultOptions = {
  showFirstLastButtons: true,
};

export const PAGE_LABEL_MAT_PAGINATOR_INTL_PROVIDER: Provider[] = [
  {
    useClass: PageLabelMatPaginatorIntl,
    provide: MatPaginatorIntl,
  },
  {
    provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
    useValue: DEFAULT_PAGINATOR_OPTIONS,
  },
];
